import { Button, InputBase, List, Paper, styled } from '../../../../../base';
import AddIcon from '@mui/icons-material/Add';

export const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    '&:hover': {
        // backgroundColor: '#6a1b9a',
        backgroundColor: theme.palette.primary.main,
        cursor: 'inherit',
    },
    width: '100%',
    justifyContent: 'space-between',
    padding: '10px 16px',
    borderRadius: '15px 15px 0 0',
    textTransform: 'none',
    fontSize: '16px',
    fontWeight: 'normal',
}));
export const StyledPaper = styled(Paper)(({ theme }) => ({
    width: '100%',
    maxHeight: 'calc(9 * 48px + 64px + 48px)', // 9 items (48px each) + search box (64px) + button (48px)
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: 'none', // Remove shadow
    border: '1px solid #e0e0e0', // Add 1px border
    borderRadius: '0 0 15px 15px', // Keep the updated bottom left and right radius
}));
export const StyledList = styled(List)({
    overflowY: 'auto',
    flex: 1,
    maxHeight: 'calc(9 * 48px)', // 9 items maximum
});
export const StyledAddButton = styled(Button)(({ theme }) => ({
    justifyContent: 'center',
    padding: '8px 16px',
    margin: '8px 12px',
    borderRadius: '20px',
    fontSize: '14px',
    width: 'calc(100% - 24px)',
    height: '35px',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.primary.main + 'B3', // 70% opacity
    },
    '&.Mui-disabled': {
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.grey[500],
    },
}));
export const StyledSearchInput = styled(InputBase)(() => ({
    width: '100%',
    '& .MuiInputBase-input': {
        padding: '10px 0',
        paddingInlineStart: '35px',
    },
}));
export const CircularAddIcon = styled(AddIcon)(() => ({
    border: '2px solid #bdbdbd',
    borderRadius: '50%',
    padding: 2,
    fontSize: 20,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));
